import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qpbga97kpu: FaireBrandEntity = {
  token: "b_qpbga97kpu",
  type: "brand",
  name: "Fomin",
  avatarUrl:
    "https://cdn.faire.com/fastly/b46419d286ae5498853e10e1789e358d61c2437d5fd3f5164f22e628574d703c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b3add61cdc90eb8e009a8f174b282248ee44d6b036478861a027ac5ccf9be219.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b46419d286ae5498853e10e1789e358d61c2437d5fd3f5164f22e628574d703c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b3add61cdc90eb8e009a8f174b282248ee44d6b036478861a027ac5ccf9be219.png",
  location: "Redlands, CA, USA",
  minimumOrderDollars: 69,
  rating: 4.9,
  reviewCount: 41,
  isTopShop: true,
  isInsider: true,
  description:
    "Fomin Soap, a collective of individuals united by the belief that cleaning should not harm the environment, was founded in 2021. \n\nThe core philosophy of Fomin revolves around the concept \"All You Need Is Less.\" This ethos reflects their commitment to sustainability, emphasizing that cleaning is not just a task but a lifestyle that can be enjoyable and environmentally friendly. Fomin's vibrant colors and rich scents in their products aim to make cleaning a fun experience. The company designs its products in California and responsibly manufactures them worldwide.\n\nFomin's story is not just about creating cleaning products but also about building a lifestyle brand that aligns with sustainable living practices. The introduction of their unique product, the paper soap, signifies an innovative approach to personal care and cleanliness, offering a convenient, eco-friendly solution for on-the-go hygiene needs. Their focus on fun packaging and natural scents aligns with their mission to make clean fun and sustainable, transforming the mundane task of cleaning into an enjoyable part of daily life.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:54.655Z",
    importedBy: "entity-db-cli",
  },
};
